import { TranslateService } from "@ngx-translate/core";
import { NzSelectOptionInterface } from "ng-zorro-antd/select";
import { map, Observable, of, switchMap } from "rxjs";
import { CmsNameValue } from "../../../api/cms/cms.types";

// [nzOptions] input for nz-select: unlike <nz-option *ngFor>, it creates no component per option, which adds up in table rows
export function toTranslatedOptions(
  items$: Observable<Array<CmsNameValue>>,
  translateService: TranslateService,
): Observable<NzSelectOptionInterface[]> {
  return items$.pipe(
    switchMap((items) =>
      items.length
        ? translateService
            .stream(items.map((item) => item.name))
            .pipe(
              map((translations: Record<string, string>) =>
                items.map((item) => ({ label: translations[item.name], value: item.value })),
              ),
            )
        : of([]),
    ),
  );
}
